import type { FilterSection } from "@/types/filterTypes";

export const useStrategicPillarsFilterSections = (): FilterSection[] => {
  return [
    {
      key: "landingPagePrioritiesOfAfsa",
      label: "Is On Landing Page?",
      type: "boolean",
    },
    {
      key: "whoWeAre",
      label: "Is In Who We Are Section?",
      type: "boolean",
    },
    {
      key: "memberCountries",
      label: "Is In Member Countries Section?",
      type: "boolean",
    },
    {
      key: "history",
      label: "Is In History Section?",
      type: "boolean",
    },
        {
      key: "leadership",
      label: "Is In Leadership Section?",
      type: "boolean",
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
